const REQUEST_TIMEOUT_MS = 10_000;

export class PortalNetworkError extends Error {
  constructor() {
    super('Invitation request failed');
    this.name = 'PortalNetworkError';
  }
}

export function normaliseEntryCode(value) {
  return typeof value === 'string'
    ? value.trim().toUpperCase().replace(/[\s-]+/gu, '')
    : '';
}

export async function requestJson(path, options, fetchImpl = fetch) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);

  try {
    const response = await fetchImpl(path, {
      credentials: 'same-origin',
      ...options,
      headers: {
        'content-type': 'application/json',
        ...options?.headers,
      },
      signal: controller.signal,
    });

    let data = { state: 'unavailable' };
    try {
      data = await response.json();
    } catch {
      // A non-JSON response is treated as a temporary service failure.
    }

    return { status: response.status, data };
  } catch {
    throw new PortalNetworkError();
  } finally {
    clearTimeout(timeout);
  }
}

export function verifyInvitation(code, fetchImpl) {
  return requestJson('/api/invite/verify', {
    method: 'POST',
    body: JSON.stringify({ code: normaliseEntryCode(code) }),
  }, fetchImpl);
}

export function confirmIdentity(confirmed, fetchImpl) {
  return requestJson('/api/invite/confirm', {
    method: 'POST',
    body: JSON.stringify({ confirmed }),
  }, fetchImpl);
}

export function restoreSession(fetchImpl) {
  return requestJson('/api/invite/session', {
    method: 'GET',
    headers: {},
  }, fetchImpl);
}

export function restoreAssessment(fetchImpl) {
  return requestJson('/api/assessment', {
    method: 'GET',
    headers: {},
  }, fetchImpl);
}
